import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from "yup";
import axios from "axios";
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
function Contact() {
    let navigate = useNavigate();
    const initValues = {
        name: "",
        email: "",
        subject: "",
        message: "",
    }
    const submit = (data) => {
        const formData = new FormData();
        formData.append("name", data.name);
        formData.append("email", data.email);
        formData.append("subject", data.subject);
        formData.append("message", data.message);
   

        axios.post("https://bntserver.bntfoundation.com/ContactPost.php", formData).then((response) => {
            // navigate('/');
            window.location.href = '/contactconfirmation';
        })
    }
    const validation1 = Yup.object().shape({
        name: Yup.string().required(),
        email: Yup.string().required(),
        subject: Yup.string().required(),
        message: Yup.string().min(5).max(5000).required(),
    })
    return (
        <div>

            <div className="hero page-inner overlay"
                style={{ backgroundImage: `url('../../Content/img/slide/BNT1.jpg')` }}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-9 text-center mt-5">
                            <h1 className="heading" data-aos="fade-up">Contact Us</h1>

                            <nav aria-label="breadcrumb"
                                data-aos="fade-up"
                                data-aos-delay="200">
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section">
                <div className="container">
                    <div className="row mb-5 mt-4">
                        <div className="col-lg-4 mb-5 mb-lg-0"
                            data-aos="fade-up"
                            data-aos-delay="100">
                            <div className="contact-info">
                                <div className="address mt-2">
                                    <i className="icon-room"></i>

                                    <p>
                                        Baba Nanak Trust Foundation <br/> Unit 203, 5119 22 Ave SW, <br /> Edmonton, AB T6X 2N4
                                    </p>
                                </div>

                                <div className="address mt-4">
                                    <i className="icon-envelope"></i>


                                    <p>
                                        <a href="mailto:seva@babananaktrust.ca">seva@babananaktrust.ca</a>
                                    </p>
                                </div>

                                <div className="address mt-5">
                                    <i className="icon-phone"></i>



                                    <p><a href="tel://780-616-5057">780-616-5057</a></p>


                                </div>


                            </div>
                        </div>

                        {/************************************** formik **************************************************/}
                        <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
                            <Formik initialValues={initValues} onSubmit={submit} validationSchema={validation1}>
                                <Form>

                                    <div className="row">
                                        <div className="col-6 mb-3">
                                            <ErrorMessage name="name" component="span" className='text-danger' />
                                            <Field
                                                name="name"
                                                className="form-control"
                                                placeholder="Your Name"
                                            />
                                        </div>
                                        <div className="col-6 mb-3">
                                            <ErrorMessage name="email" component="span" className='text-danger' />
                                            <Field
                                                name="email"
                                                className="form-control"
                                                placeholder="Your Email"
                                            />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <ErrorMessage name="subject" component="span" className='text-danger' />

                                            <Field
                                                name="subject"
                                                className="form-control"
                                                placeholder="Subject"
                                            />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <ErrorMessage name="message" component="span" className='text-danger' />

                                            <Field
                                                name="message"
                                                id=""
                                                className="form-control"
                                                placeholder="Message"
                                            />
                                        </div>

                                        <div className="col-12">
                                            <button type="submit" className="btn btn-secondary">Submit</button>
                                        </div>
                                    </div>
                                </Form>
                            </Formik>
                        </div>
















                    </div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d707.0123329334049!2d-113.42173773191597!3d53.41309949814875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53a01bf5bc1e6163%3A0x4026c7ddb810ec7!2s5119%2022%20Ave%20SW%20%23203%2C%20Edmonton%2C%20AB%20T6X%201A4%2C%20Canada!5e0!3m2!1sen!2sin!4v1768991745159!5m2!1sen!2sin"  width="100%" height="450" style={{border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Location Map"></iframe>
                </div>
            </div>
            
        </div>
    )
}

export default Contact;